import FilterForm from '../../../components/forms/FilterForm';
import { CanAccess, CrudFilters, HttpError } from '@refinedev/core';
import { DeleteButton, EditButton, TextField, useTable } from '@refinedev/antd';
import { EyeOutlined } from '@ant-design/icons';
import { Form, Input, Space, Table } from 'antd';
import { IInstructor } from 'interfaces/instructors';
import { ListLayout } from 'components/layout/layout/ListLayout';

interface IFilter {
  name: string;
}

export const InstructorList = () => {
  const { tableProps, searchFormProps } = useTable<
    IInstructor,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { name } = params;

      filters.push({
        field: 'filter[name]',
        operator: 'eq',
        value: name
      });

      return filters;
    }
  });

  return (
    <ListLayout title="Instrutores">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="name">
          <Input placeholder="Nome do instrutor" className="lg:w-96" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="headline"
          key="headline"
          title="Cabeçalho"
          render={value => <TextField value={value} />}
        />
        <Table.Column<IInstructor>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={100}
          render={(_, record) => {
            return (
              <Space>
                <CanAccess resource="instructors" action="edit">
                  <EditButton
                    hideText
                    size="small"
                    recordItemId={record.id}
                    icon={<EyeOutlined />}
                  />
                </CanAccess>
                <CanAccess resource="instructors" action="delete">
                  <DeleteButton
                    size="small"
                    recordItemId={record.id}
                    hideText
                  />
                </CanAccess>
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
